
export const MuiTextField = {
    defaultProps: {
        inputProps: { maxLength: 500 }
    },
    styleOverrides: {
        root: {
            "& .MuiOutlinedInput-root": {
                borderRadius: 8,

                "&:not(.MuiInputBase-multiline)": {
                    height: 48,
                },
                "&:hover fieldset": {
                    borderWidth: '2px',
                    borderColor: 'var(--mui-palette-primary-main)'
                },
                "fieldset": {
                    borderColor: 'var(--mui-palette-primary-main)'
                }
            },
            "& .MuiInput-underline:before": {
                borderBottomColor: 'var(--mui-palette-primary-main)'
            },
            "& .MuiInput-underline:hover:before": {
                borderBottomColor: 'var(--mui-palette-primary-main)'
            },
            "& .MuiInput-underline:hover:after": {
                borderBottomColor: 'var(--mui-palette-primary-main)'
            },
            "& .MuiInput-underline:after": {
                borderBottomColor: 'var(--mui-palette-primary-main)'
            },
            "& .MuiInputLabel-root": {
                lineHeight: '1em',
                paddingRight: '1.8em',
                fontSize: '1rem'
            },
            "& .MuiInputLabel-outlined": {
                color: 'var(--mui-palette-secondary-textIconColor)'
            },
            "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
                color: 'var(--mui-palette-primary-main)'
            },
            "& .Mui-error": {
                color: 'var(--mui-palette-red-900) !important'
            },
            "& .Mui-error > .MuiOutlinedInput-notchedOutline": {
                borderColor: 'var(--mui-palette-red-900)',
                borderWidth: '2px',
            },
            '.MuiSelect-outlined': {
                fontSize: '1rem',
                fontWeight: 400,
                width: '-moz-available'
            },
            'input': {
                textOverflow: 'ellipsis',
                fontSize: '1rem',
                '&::-webkit-input-placeholder': {
                    fontSize: '1rem',
                    color: 'var(--mui-palette-secondary-textIconColor)'
                },
                paddingLeft: '12px',
                color: 'var(--mui-palette-primary-textColor)',
            }
        }
    }
}
